export const ALLOWED_DASHBOARD_HOSTS = [
  'wmg-prod.cloud.databricks.com',
  'wmg-dev.cloud.databricks.com',
];
